<script>
import { TemplateAnnotations } from '@magnolia/template-annotations';

const inIframe = typeof window !== 'undefined' ? window.self !== window.top : false;
const inMgnlIframe = inIframe && window.location.search.indexOf('mgnlPreview') > -1;
const inEditor = inIframe && window.location.search.indexOf('mgnlPreview=false') > -1;

const insertComments = (node, commentOpen, commentClose) => {
  if (node) {
    node.parentNode.insertBefore(document.createComment(commentOpen), node);
    node.parentNode.insertBefore(document.createComment(commentClose), node.nextSibling);
  }
};

const ajouterBadgeAffichage = (node, content) => {
  let html = '';
  if (content.affichage) {
    html += `<div class="badge badge-warning mr-1">${content.affichage}</div>`;
  }
  if (content.affichageConnexion) {
    html += `<div class="badge badge-warning mr-1">${content.affichageConnexion}</div>`;
  }
  if (content.dateDebut) {
    html += `<div class="badge badge-warning mr-1">${content.dateDebut}</div>`;
  }
  if (content.dateFin) {
    html += `<div class="badge badge-warning mr-1">${content.dateFin}</div>`;
  }
  if (content.affichageStatusFlag && content.affichageStatusFlag.length > 0) {
    html += `<div class="badge badge-warning mr-1">${content.affichageStatusFlag} ${
      content.affichageStatusFlagCondition ? `(${content.affichageStatusFlagCondition})` : ''
    }</div>`;
  }
  if (content.affichageProductSource && content.affichageProductSource.length > 0) {
    html += `<div class="badge badge-warning mr-1">${content.affichageProductSource}</div>`;
  }

  if (html.length > 0) {
    const range = document.createRange();
    const frag = range.createContextualFragment(html);
    node.parentNode.insertBefore(frag, node);
  }
};

// Code original Magnolia
/*
const getProps = (node) => {
  const props = {};
  const metadata = {};

  Object.keys(node).forEach((key) => {
    if (key.match(/^(@|mgnl:|jcr:)/)) {
      metadata[key] = node[key];
    } else {
      props[key] = node[key];
    }
  });

  props.metadata = metadata;

  return props;
}; 
*/

// Permettre de passer toutes les propriétés dans "content"
// Ceci permet d'ajouter une propriété dans Magnolia
// sans avoir à la déclarer explicitement dans "props" du component Vue.
export const getProps = (node) => {
  const props = {};
  const metadata = {};
  const content = {};

  Object.keys(node).forEach((key) => {
    if (key.match(/^(@|mgnl:|jcr:)/)) {
      metadata[key] = node[key];
    } else {
      content[key] = node[key];
    }
  });

  props.metadata = metadata;
  props.content = content;

  return props;
};

export const EditablePage = {
  name: 'EditablePage',
  props: ['content', 'config', 'templateDefinitions'],
  data() {
    return {
      pageTemplateId: this.content['mgnl:template'],
    };
  },
  provide() {
    return {
      config: this.config,
      templateDefinitions: this.templateDefinitions,
      pageTemplateId: this.pageTemplateId,
    };
  },
  mounted() {
    const templateDefinition = this.templateDefinitions[this.pageTemplateId];
    const commentOpen = TemplateAnnotations.getPageCommentString(this.content, templateDefinition);

    if (inMgnlIframe) insertComments(this.$el, commentOpen, '/cms:page');
  },
  render(createElement) {
    const template = this.config.componentMappings[this.pageTemplateId];
    return template
      ? createElement(template, {
          props: getProps(this.content),
        })
      : null;
  },
};

export const EditableComponent = {
  name: 'EditableComponent',
  inject: ['config', 'templateDefinitions', 'pageTemplateId'],
  props: ['content'],
  data() {
    return {
      componentTemplateId: this.content['mgnl:template'],
    };
  },

  mounted() {
    const templateDefinition = this.templateDefinitions[this.componentTemplateId];
    const commentOpen = TemplateAnnotations.getComponentCommentString(
      this.content,
      templateDefinition
    );

    if (inEditor) {
      insertComments(this.$el, commentOpen, '/cms:component');
      ajouterBadgeAffichage(this.$el, this.content);
    }
  },
  render(createElement) {
    const template = this.config.componentMappings[this.componentTemplateId];

    return template
      ? createElement(template, {
          props: getProps(this.content),
        })
      : null;
  },
};

export const EditableArea = {
  name: 'EditableArea',
  components: {
    EditableComponent,
  },
  inject: ['config', 'templateDefinitions', 'pageTemplateId'],
  props: ['content', 'parentTemplateId'],
  mounted() {
    const parentTemplateId = this.parentTemplateId || this.pageTemplateId;
    const templateDefinition = this.templateDefinitions[parentTemplateId];
    const commentOpen = TemplateAnnotations.getAreaCommentString(this.content, templateDefinition);

    if (inEditor) insertComments(this.$el, commentOpen, '/cms:area');
  },
  render(createElement) {
    const nodes = this.content['@nodes'].map((nodeName) => this.content[nodeName]);

    return createElement(
      'div',
      null,
      nodes.map((node) => createElement(EditableComponent, { props: { content: node } }, null))
    );
  },
};

export default EditablePage;
</script>
